var _rect, _rect2, _path, _rect3, _rect4, _rect5, _path2, _path3, _path4, _rect6, _rect7, _rect8, _path5, _path6, _path7;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMultipleItemsAllIncludedActive(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 164,
    height: 124,
    viewBox: "0 0 164 124",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 162,
    height: 122,
    rx: 5,
    fill: "#F0F9F5",
    stroke: "#68C598",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 64,
    y: 102,
    width: 36,
    height: 9,
    rx: 4.5,
    fill: "#68C598"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M129.718 16H34.2824C31.9173 16 30 20.2533 30 25.5V82.5C30 87.7467 31.9173 92 34.2824 92H129.718C132.083 92 134 87.7467 134 82.5V25.5C134 20.2533 132.083 16 129.718 16Z",
    fill: "white",
    stroke: "#D9D9D9",
    strokeWidth: 1.5
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0054,
    y: 28.5703,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 36.5703,
    width: 30,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 40.998,
    width: 25,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 25H48V49H72V25ZM70.9634 26.0808H49.0797V47.9808H70.9634V26.0808Z",
    fill: "#68C598"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8974 41.6676L57.1438 34.5371L50.2866 44.8228H59.6888L59.6541 44.8724H69.2541L64.4541 38.0152L61.8974 41.6676Z",
    fill: "#68C598"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8598 35.9775C67.3923 35.9775 68.6347 34.7478 68.6347 33.2309C68.6347 31.7141 67.3923 30.4844 65.8598 30.4844C64.3273 30.4844 63.085 31.7141 63.085 33.2309C63.085 34.7478 64.3273 35.9775 65.8598 35.9775Z",
    fill: "#68C598"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 88.0054,
    y: 61.7109,
    width: 30,
    height: 3,
    rx: 1.5,
    fill: "#BBBBBB"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 69.7109,
    width: 30,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 88,
    y: 74.1387,
    width: 25,
    height: 1.5,
    rx: 0.75,
    fill: "#D9D9D9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72 58.1406H48V82.1406H72V58.1406ZM70.9634 59.2214H49.0797V81.1214H70.9634V59.2214Z",
    fill: "#68C598"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M61.8974 74.8082L57.1438 67.6777L50.2866 77.9634H59.6888L59.6541 78.013H69.2541L64.4541 71.1559L61.8974 74.8082Z",
    fill: "#68C598"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M65.8598 69.1181C67.3923 69.1181 68.6347 67.8884 68.6347 66.3716C68.6347 64.8547 67.3923 63.625 65.8598 63.625C64.3273 63.625 63.085 64.8547 63.085 66.3716C63.085 67.8884 64.3273 69.1181 65.8598 69.1181Z",
    fill: "#68C598"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMultipleItemsAllIncludedActive);
export default __webpack_public_path__ + "static/media/multiple-items-all-included-active.475d77ae4cb35827218e741a69a84c58.svg";
export { ForwardRef as ReactComponent };